import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { RootState } from '../../features';
import { Logo } from '../shared/Logo';
import { DialogRoute } from '../shared/routes/DialogRoute';
import { FadeRoute } from '../shared/routes/FadeRoute';
import { HomeScreen } from './HomeScreen';
import { NotificationCenter } from './notifications/NotificationCenter';
import { ReportedWarningDialog } from './ReportedWarningDialog';

const Home: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { selectedUserId, users, splashFinished, reportedWarningFinished } = useSelector(
    (state: RootState) => state.user
  );
  const selectedUser = users.find(u => u.id === selectedUserId);
  const isReported = selectedUser?.screening === 'ng';

  useEffect(() => {
    if (isReported && !reportedWarningFinished && splashFinished) {
      const pageParam = history.location.search;
      history.push(`/players/home/reported-warning${pageParam}`);
    }
  }, [isReported, splashFinished, reportedWarningFinished, history]);

  if (!selectedUser) {
    return <Redirect to="/" />;
  }

  const isNotificationCenterOpen = location.pathname === '/players/home/notifications';

  return (
    <>
      <main
        className={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          min-height: 100%;
          background: radial-gradient(rgb(245, 236, 202) 16%, transparent 0),
            radial-gradient(rgb(245, 236, 202) 16%, transparent 0), rgb(237, 225, 184);
          background-position: 0 0, 12px 12px;
          background-size: 24px 24px;
          padding: 12px 0;
          padding-bottom: calc(12px + env(safe-area-inset-bottom));
          overflow: hidden;
          filter: ${isNotificationCenterOpen ? 'blur(8px)' : 'none'};

          .logo {
            opacity: ${splashFinished ? 1 : 0};
            transform: ${splashFinished ? 'none' : 'scale(0.85)'};
            transition: all 0.2s cubic-bezier(0.17, 0.89, 0.56, 1.72);
          }
        `}
      >
        <div className="logo">
          <Logo />
        </div>
        <HomeScreen user={selectedUser} />
      </main>
      <DialogRoute path="/players/home/reported-warning">
        <ReportedWarningDialog />
      </DialogRoute>
      <FadeRoute path="/players/home/notifications">
        <NotificationCenter />
      </FadeRoute>
    </>
  );
};

export default Home;
